import React from 'react';
import { Phone, ArrowLeft, Shield, RefreshCw, Check, AlertCircle } from 'lucide-react';

const OTPVerificationModal = ({
  mobile,
  otp,
  handleOtpChange,
  handleOtpKeyDown,
  otpMethod,
  timer,
  canResend,
  resendOTP,
  verifyOTP,
  setAuthStep,
  userProfile,
  setUserProfile,
  error
}) => {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white w-full max-w-md rounded-3xl p-8 shadow-2xl my-8 transform transition-all relative z-10">
        <button
          onClick={() => setAuthStep('phone')}
          className="flex items-center gap-2 text-gray-600 mb-6 hover:text-blue-600 transition-colors font-medium group"
        >
          <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
          <span>Back</span>
        </button>

        <div className="text-center mb-8">
          <div className="relative inline-block mb-4">
            <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-emerald-600 rounded-3xl flex items-center justify-center mx-auto shadow-lg transform rotate-3 hover:rotate-0 transition-transform duration-300">
              <Shield size={48} className="text-white transform -rotate-3" />
            </div>
            <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
              <Phone size={16} className="text-white" />
            </div>
          </div>
          <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
            Verify OTP
          </h2>
          <p className="text-gray-600 mb-1">
            Code sent via {otpMethod === 'sms' ? '📱 SMS' : '💬 WhatsApp'} to
          </p>
          <p className="font-bold text-gray-800 text-lg">+91 {mobile}</p>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-4 text-center">
            Enter 6-digit verification code
          </label>
          <div className="flex gap-2 justify-center mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                className={`w-12 h-14 text-center text-2xl font-bold border-2 rounded-xl outline-none transition-all ${
                  digit 
                    ? 'border-blue-500 bg-blue-50 text-blue-600 scale-105' 
                    : 'border-gray-300 bg-gray-50 hover:border-blue-300'
                }`}
              />
            ))}
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
              <AlertCircle size={18} className="text-red-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <div className="text-center bg-gray-50 rounded-xl p-3">
            {canResend ? (
              <button
                onClick={resendOTP}
                className="text-blue-600 font-semibold hover:text-purple-600 transition-colors inline-flex items-center gap-2 group"
              >
                <RefreshCw size={16} className="group-hover:rotate-180 transition-transform duration-500" />
                <span>Resend OTP</span>
              </button>
            ) : (
              <p className="text-gray-600 inline-flex items-center gap-2">
                <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></span>
                Resend available in <span className="font-bold text-blue-600 text-lg mx-1">{timer}s</span>
              </p>
            )}
          </div>
        </div>

        <button
          onClick={verifyOTP}
          disabled={otp.join('').length !== 6}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-4 rounded-2xl font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all disabled:from-gray-300 disabled:to-gray-400 disabled:cursor-not-allowed disabled:shadow-none transform hover:scale-[1.02] active:scale-[0.98] group relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
          <span className="relative z-10 inline-flex items-center gap-2">
            <Check size={20} />
            Verify & Continue
          </span>
        </button>

        <div className="mt-6 p-4 bg-blue-50 rounded-xl border border-blue-200">
          <p className="text-sm text-blue-800 text-center">
            <span className="font-semibold">💡 Demo Mode:</span> Use code <span className="font-mono font-bold">123456</span>
          </p>
        </div>

        <p className="text-xs text-gray-400 text-center mt-4">
          🔒 Your data is encrypted and secure
        </p>
      </div>
    </div>
  );
};

export default OTPVerificationModal;